export type TMobileState = {
    mobileAppPath: string | null
    platform: 'Android' | 'iOS' | 'Web' | null
    hasArrivedFromMobile: boolean
    productIndex: number | null
    priorScreenName: string | null
    bundleId: string | null
}

export const getInitialMobileState = (): TMobileState => {
    return {
        hasArrivedFromMobile: false,
        mobileAppPath: null,
        platform: null,
        productIndex: null,
        priorScreenName: null,
        bundleId: null,
    }
}

const moduleState = getInitialMobileState()

export default moduleState
